export { default } from "./ListItemIndexMobile";
